/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import ItemList from "./ItemList/ItemList";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { get, isEmpty, isUndefined } from "lodash";
import ItemHistories from "./History/ItemHistories";
import { getProductsDownloadExcel, getProductsDownloadExcelSample, getProductsList, postProductsMultiple } from "../../apis/companies/products";
import { downExcelFile, download } from "../../utils/download";
import systemAlert from "../../utils/systemAlert";
import { postFilesExcel } from "../../apis/files";
import { excelUploadData } from "../../utils/excelUploadData";
import { viewLoading } from "../../utils/loading";
import { getParams } from "../../utils/params";
import useForm from "../../hooks/useForm";
import { permissionCheck } from "../../utils/permission";

const Item = (props) => {
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions,
  }));
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);

  const _setActiveTab = (value) => {
    history.push(`/item/list?tab=${value}`);
  };

  const [detailOpen, setDetailOpen] = useState(false);

  const tabList = [
    {
      label: "품목 관리",
      action: _setActiveTab,
      value: 'item-list'
    },
    {
      label: "변경 내역",
      action: _setActiveTab,
      value: 'item-history'
    },
  ];
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'PRODUCT')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "PRODUCT")
      }
    }
  }, [permissions])

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  // {
  //   form,
  //   setSubmit,
  //   handleOnChange,
  //   handleSubmit,
  //   // LIST 용
  //   filterSubmit,
  //   list, setList,
  //   selectedList, setSelectedList,
  //   isLoading, setIsLoading,
  //   total, setTotal,
  //   page, setPage,
  //   limit, setLimit,
  // }
  const useFormItem = useForm(
    {
      searchType: 'name',
      searchText: '',
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    if (targetPermission) {
      submit(useFormItem.form);
      useFormItem.setSubmit(submit)
    }
  }, [targetPermission]);

  const submit = (param) => {
    getProductsList(getParams(param))
      .then((res) => {
        useFormItem.setTotal(res.data.count);
        res.data.products = res.data.products.map((product) => ({
          ...product,
          buyPrice: String(product.buyPrice),
          sellPrice: String(product.sellPrice),
        }));
        useFormItem.setList(get(res, "data.products"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        useFormItem.setIsLoading(false)
        useFormItem.setSelectedList([]);
      });

  };

  const handleSampleDown = () => {
    getProductsDownloadExcelSample()
      .then((res) => {
        download(res.data.url);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const uploadExcelFile = (e) => {
    const file = e.target.files[0];
    if (!isUndefined(file)) {
      const formData = new FormData();
      formData.append("file", file);
      systemAlert(`"${file.name}" 파일을 업로드 하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소",
          },
          {
            label: "업로드",
            onClick: () => {
              postFilesExcel(formData)
                .then((res) => {
                  const rows = get(res, "data.sheets[0].rows");
                  const keys = [
                    { idx: 1, key: "category", type: String },
                    { idx: 2, key: "code", type: String },
                    { idx: 3, key: "division", type: String },
                    { idx: 4, key: "name", type: String },
                    { idx: 5, key: "size", type: String },
                    { idx: 6, key: "unit", type: String },
                    { idx: 7, key: "buyPrice", type: Number },
                    { idx: 8, key: "sellPrice", type: Number },
                    { idx: 9, key: "memo", type: String },
                  ];

                  const excelData = {
                    products: excelUploadData({ keys, rows }),
                  };

                  postProductsMultiple(excelData)
                    .then(() => {
                      submit(useFormItem.form);
                    })
                    .catch((err) => {
                      console.error(err.response);
                    });
                })
                .catch((err) => {
                  console.error(err.response);
                });
            },
          },
        ],
      });
    }
  };

  const headerButtons = [
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      color: "gray-line",
      label: (
        <>
          샘플파일 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: handleSampleDown,
    },
    // {
    //   color: "gray-line",
    //   label: "인쇄",
    //   action: () => window.print(),
    // },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "엑셀업로드",
      type: "excelFile",
      onChange: (e) => uploadExcelFile(e),
    },
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        viewLoading(true)
        getProductsDownloadExcel(getParams(useFormItem.form, true))
          .then((res) => {
            viewLoading(false)
            downExcelFile(res, "품목_목록.xlsx");
          })
      }
    },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "품목 추가",
      action: () => {
        setDetailOpen(true);
      },
    },
  ]

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader
          title={"품목"}
          activeTab={activeTab}
          tabList={tabList}
          buttons={activeTab === 'item-list' ? headerButtons : []}
        />
        {activeTab === 'item-list' && (
          <ItemList
            useFormItem={useFormItem}
            permission={targetPermission}
            detailOpen={detailOpen}
            setDetailOpen={setDetailOpen}
            submit={useFormItem.filterSubmit}
          />
        )}
        {activeTab === 'item-history' && (
          <ItemHistories />
        )}
      </>
    ));
};

export default Item;
